<template>
  <div class="vue-rqf-page mpsOrder" :style="{filter: ($route.name == 'request' && $root.ui.loading == 'getRequest') ? 'blur(6px)' : 'none'}">

    <div class="orderFeed">

      <template v-for="(item,idx) in feed.items">
        <template v-if="item.type == 'comment' && !$root.isAdminPage()">
          <div class="opqCommentDate" v-text="$root.formatDate(item.date, true, true)"></div>
          <div :class="['opqComment', item.content.id_owner ? 'admin' : 'client']">
            <div class="opqCommentText" v-html="item.content.text">
            </div>
          </div>
        </template>
        <template v-if="item.type == 'offer'">
          <div class="currentOpqOffer">
            <template>
              <h3>Tilbud på oppretting av bilskader</h3>
              <table class="opqOffer">
                <thead>
                <tr>
                  <th>Beskrivelse</th>
                  <th>Beløp<br> (eks. mva)</th>
                  <th>Mva<br> (25%)</th>
                  <th>Beløp<br> (inkl. mva)</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(damage,idx) in $root.damages">
                  <tr class="bt">
                    <td>
                      <b v-text="idx+1 + '. ' + damage.type.join(', ')"></b></br>
                    </td>
                    <template v-if="damage.offer_price">
                      <td><span v-text="damage.offer_price.toFixed(0)"></span></td>
                      <td><span v-text="(damage.offer_price*0.25).toFixed(0)"></span></td>
                      <td><span v-text="(damage.offer_price*1.25).toFixed(0)"></span> kr</td>
                    </template>
                    <template v-else>
                      <td colspan="3"></td>
                    </template>
                  </tr>
                  <tr v-if="damage.offer_discount">
                    <td colspan="3">Rabatt <span v-if="$root.contact.is_naf_member && damage.offer_discount">NAF</span> <span v-text="damage.offer_discount+'%'"></span></td>
                    <td><span v-text="(-damage.offer_price*1.25*damage.offer_discount/100).toFixed(0)"></span> kr</td>
                  </tr>
                  <tr v-if="damage.offer_text">
                    <td v-text="damage.offer_text" colspan="4"></td>
                  </tr>
                </template>
                </tbody>
                <tfoot>
                <tr>
                  <td><b>Sum</b></td>
                  <td><span v-text="(item.totalPrice + item.rentalPrice).toFixed(0)"></span></td>
                  <td><span v-text="((item.totalPrice + item.rentalPrice)*item.tax).toFixed(0)"></span></td>
                  <td><span v-text="((item.totalPrice + item.rentalPrice)*(1+item.tax)).toFixed(0)"></span> kr</td>
                </tr>
                <tr>
                  <td><b>Tilbud</b></td>
                  <td colspan="3"><b><span v-text="((item.totalPrice + item.rentalPrice)*(1+item.tax)).toFixed(0)"></span> kr</b></td>
                </tr>
                </tfoot>
              </table>
              <button v-if="isAdminRoute()" @click="editOffer" :disabled="$root.ui.loading" class="button primary">Redigere</button>
            </template>
            <template v-if="!parseInt($root.request.offer_status) && isClientRoute()">
              <div v-else class="opqOfferActions">
                <button :disabled="$root.ui.loading" @click.prevent="considerOffer(1)" id="js-accept-offer" class="button primary">Ja takk! Bestill time</button>
                <button :disabled="$root.ui.loading" @click.prevent="considerOffer(-1)" id="js-decline-offer" class="button secondary">Nei takk</button>
              <!-- rejectOffer(true) -->
              </div>
            </template>
            <div v-if="$root.isAdminPage()" class="opqOfferActions">
              <button :disabled="$root.ui.loading" @click.prevent="$root.newRequest" class="button primary">Ny prisforespørsel</button>
            </div>
          </div>
        </template>
      </template>
      <div v-if="$route.params.code && $root.isActiveOfferService() && !$root.isAdminPage() && !$root.isAddedByWorkshop()" :class="['opqComment', $route.params.type]">
        <div class="opqCommentText">
          <textarea v-model="newComment" rows="4" class="opqCommentField" placeholder="Skriv inn spørsmål eller kommentar til tilbudet">
          </textarea>
          <span class="v-error" v-if="$root.validate && !newComment">Comment is required</span>
          <div style="text-align:right">
            <button :disabled="$root.ui.loading" @click.prevent="sendComment" id="js-add-comment" class="button primary">Send</button>
          </div>
        </div>
      </div>
    </div>
    <div class="damages-wrap">
      <h3>{{ $root.isAdminPage() ? 'Taksering av skade' : 'Oppsumering av din forespørsel' }}</h3>
      <div class="partner-logo left" v-if="$root.fleetCompany"><img :src="$root.fleetCompany.logo" /></div>

      <h4 v-text="$root.contact.name"></h4>
      <dl class="result-list">
        <div v-if="$root.request.car_id">
          <dt>Reg.nr:</dt>
          <dd v-text="$root.request.car_id"></dd>
        </div>
        <div v-if="$root.car.model">
          <dt>Bil:</dt>
          <dd v-text="$root.car.producer + ' ' + $root.car.model"></dd>
        </div>
        <div>
          <dt>Mobil:</dt>
          <dd v-text="$root.contact.phone"></dd>
        </div>
        <div>
          <dt>E-post:</dt>
          <dd v-text="$root.request.ext_recipient_email ? $root.request.ext_recipient_email : $root.contact.email"></dd>
        </div>
        <div v-if="$root.request.ext_ref">
          <dt>Referanse:</dt>
          <dd v-text="$root.request.ext_ref"></dd>
        </div>
      </dl>
      <template v-if="$root.workshop">
        <h4>Verksted</h4>
        <dl class="result-list">
          <div>
            <dt v-text="$root.workshop.name">Lambertseter</dt>
          </div>
          <div>
            <dt>Mobil:</dt>
            <dd v-text="$root.workshop.phone"></dd>
          </div>
          <div>
            <dt>E-post:</dt>
            <dd v-text="$root.workshop.email"></dd>
          </div>
        </dl>
      </template>
      
      <div class="damages-form">
        <div class="damage">
          <template v-for="(damage,damageIndex) in $root.damages">
            <div class="preview-wrap">
              <ul class="preview">
                <li v-for="(fileId,index) in damage.images">
                  <a target="_blank"  :href="$root.files[fileId].url">
                    <img :src="$root.files[fileId].url" :alt="'Skade ' + (index+1)">
                  </a>
                </li>
              </ul>
              <span class="marker-num" v-text="damageIndex+1"></span>
            </div>
            <div v-if="damage.description" class="description" v-text="damage.description"></div>
            <div v-if="$root.offerFormIsNeeded()" class="opqDamageOffer">
              <v-select placeholder="Velg type skade" multiple v-model="damage.type" :options="$root.damageTypes"></v-select>
              <div class="textSelector">
                <v-select :on-change="function(val){$root.autoReplyChange(val,damage);}" class="opqOfferText" placeholder="Merknad" v-model="damage.offer_text" :options="$root.damageOfferTexts"></v-select>
                <textarea placeholder="Merknad" v-model="damage.offer_text" rows="4" class="opqOfferComment"></textarea>
              </div>
              <div>
                <input class="opqDamagePrice" type="number" v-model="damage.offer_price" placeholder="Pris eks mva"/>
                <input class="opqDamageDiscount" type="number" v-model="damage.offer_discount" placeholder="Rabatt %"/>
                <label v-if="damage.offer_discount_reason" style="font-size:13px; float:right;" >{{ damage.offer_discount_reason }}</label>
              </div>
            </div>
          </template>
          <div id="car-model" class="model">
            <div class="model-inner">
              <img src="/wp-content/plugins/autotaksering/requests/assets/img/tesla-model-s.png" alt="Model">
              <template v-for="(damage,index) in $root.damages">
                <div v-if="damage.position"
                  class="marker"
                  v-bind:style="'top:'+damage.position.top+'%;left:'+damage.position.left+'%;'"
                  v-text="index+1"></div>
              </template>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class="opqOfferActions left">
      <button v-if="$root.isAdminUser()" :disabled="$root.ui.loading" @click.prevent="exportToXbulk" class="button primary">Send til Xbulk</button>
      <button v-if="isAdminRoute() && !$root.isRequestFinished() && $root.isOfferConsidered()" :disabled="$root.ui.loading" @click.prevent="setAsFinished" class="button primary">Merk som ferdig</button>
      <button v-if="isAdminRoute()" :disabled="$root.ui.loading" @click.prevent="$root.newRequest" class="button primary">Ny prisforespørsel</button>
      <div v-if="isAdminRoute() && $root.isAdminUser()">
        <button :disabled="$root.ui.loading" @click.prevent="setAsContacted" class="button pink">Kunde kontaktet</button>
        <p class="mpsBtnDesc" v-if="$root.request.contact_date" v-text="$root.customDateFormat($root.request.contact_date)"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      newComment: '',
      xbulk_technicians: null,
      rejectOfferDialogTimeout: null
    }
  },
  computed: {
    comments: function(){
      return this.$store.getters.comments
    },
    feed: function(){
      var self = this;

      var comments = self.comments.map(function(item){
        return {
          type: 'comment',
          content: item,
          date: item.created_at
        }
      })

      var items = [];

      console.log(self.$root.request.offer_date);

      var price = new Date(self.$root.request.created_at) > new Date("2021-12-31 23:59:59") ? 450 : 395;

      if(self.$root.request.offer_date && !self.$root.isNoPriceOffer())
        items.push({
          type: 'offer',
          date: self.$root.request.offer_date,
          rentalPrice: self.$root.request.offer_estimation * price,
          totalPrice: self.$root.damages.map(function(dmg){
            var offer_price = parseFloat(dmg.offer_price);
            var offer_discount = parseFloat(dmg.offer_discount);
            dmg.offer_price = offer_price ? offer_price : 0;
            dmg.offer_discount = offer_discount ? offer_discount : 0;

            var i = dmg.offer_discount ? 1-dmg.offer_discount/100 : 1;
            return dmg.offer_price * i;
          }).reduce(function(a,b){
            return a+b;
          }),
          tax: 0.25
        });

      let offer_status = parseInt(self.$root.request.offer_status);
      if(self.$root.isOfferConsidered()) {
        let confirmationText;

        if(offer_status == 1)
        {
          confirmationText = 'Tilbud akseptert – jeg ønsker å reparere bilen min';
        }
        if(offer_status == -1)
        {
          confirmationText = 'Tilbudet avslått';
        }
        items.push({
          type: 'comment',
          content: {
            id_owner: null,
            text: confirmationText
          },
          date: self.$root.request.offer_consideration_date
        });
        if (offer_status > 0)
          items.push({
            type: 'comment',
            content: {
              id_owner: true,
              text: 'Takk! Vi tar kontakt med deg så snart vi kan for å avtale tidspunkt.'
            },
            date: self.$root.request.offer_consideration_date
          });

      }

      items = items.concat(comments).sort(function (a, b) {
        var aDate = new Date(a.date.replace(/-/g, "/"));
        var bDate = new Date(b.date.replace(/-/g, "/"));
        if(a.date == b.date){
          return a.type == 'offer' ? 1 : -1;
        }
        if (aDate > bDate)
          return 1;

        if (aDate < bDate)
          return -1;

        return 0;
      });
      return {
        items: items
      }
    }
  },
  methods: {
    showSmsDialog(){
        let self = this


        let sms_text = "Hei! Vi har fått i oppdrag av Tesla å utbedre bilen din. Vennligst kontakt oss for å booke en tid for utbedring.\n" +
            "Hilsen " + self.$root.workshop.name + ". T: " + self.$root.workshop.phone + " / " + self.$root.workshop.email + "\n" +
            "Denne sms kan ikke besvares";
      /*
        let sms_text = "Hei\n" +
            "Jeg forsøkte nettopp å ringe deg.\n" +
            "Vi har fått i oppdrag av Tesla å utbedre skader på din bil.\n" +
            "Vennligst kontakt oss slik at vi kan få booket deg inn på ett av våre verksted.\n\n" +
            "Mvh\n" +
            "Annette\n" +
            "Customer Success Manager\n\n" +
            self.$root.workshop.name + "\n\n" +
            self.$root.workshop.phone + "\n" +
            self.$root.workshop.email + "\n\n" +
            "Denne sms kan ikke besvares";
        */
        let data = {
            phone_number: self.$root.contact.phone,
            sms_text: sms_text,
            id_request: self.$root.request.id
        }
        self.$dialog.confirm(JSON.stringify(data), {
            view: 'sms-dialog',
            backdropClose: true,
            customClass: ['smsDialog', 'mpsConfirmDialog']
        }).then((res)=>{
            if(!res.data) return;
            self.sendSms(res.data)
        });
    },
    confirmTeslaOffer(){
      let self = this
      self.$dialog.confirm('', {
        view: 'accept-offer',
        backdropClose: true,
        customClass: ['mpsConfirmDialog', 'accept']
      }).then((res)=>{
        if(!res.data) return;

        self.$root.request.po_number = res.data
        self.considerOffer(1)
      });
    },
    rejectTeslaOffer(){
      let self = this
      self.$dialog.confirm('', {
        view: 'reject-tesla-offer',
        backdropClose: true,
        customClass: ['mpsConfirmDialog', 'reject']
      }).then((res)=>{
        if(res.data == 'reject')
          self.considerOffer(-1);
        if(res.data == 'reconsider') {
          self.newComment = "Jobben er feilpriset.";
          self.sendComment()
        }
      });
    },
    rejectOfferDialogIsOpened(){
      return this.rejectOfferDialog && this.rejectOfferDialog._state === 0;
    },
    rejectOffer(strict){
        let self = this
        if( self.$root.isOfferConsidered() )
            return;
        if( self.rejectOfferDialogIsOpened() || !self.isClientRoute() )
            return;
        if(self.rejectOfferDialogTimeout){
          clearTimeout(self.rejectOfferDialogTimeout);
          self.rejectOfferDialogTimeout = null
        }
        let id_insurance_company = self.$root.insuranceCompany ? self.$root.insuranceCompany.id : null ;
        self.rejectOfferDialog = self.$dialog.confirm('', {
            view: 'reject-offer',
            insurance_companies: self.$root.insuranceCompanies,
            id_company: id_insurance_company,
            backdropClose: true,
            customClass: ['mpsConfirmDialog', 'reject']
        }).then((res)=>{
            if(strict && res.data.result == 'reject')
                self.considerOffer(-1);
            if(res.data.result == 'reconsider') {
                self.considerOffer( 0, {
                    offer_insurance_id_company: res.data.id_company
                });
                self.newComment = "Kunden ønsker informasjon om bruk av forsikringen";
                self.sendComment()
            }
            return res
        });
    },
    editOffer(){
      this.$root.isOfferFormActive = true
      this.$root.previousOfferForm = $('.currentOpqOffer .opqOffer').get(0).outerHTML;
      $("html, body").animate({ scrollTop: $(".damages-form").last().offset().top }, "slow");
    },
    isAdminRoute(){
        return this.$route.params.type == 'admin'
    },
    isClientRoute(){
        return this.$route.params.type == 'client'
    },
    exportToXbulk(){
      let self = this
      console.log(self.xbulk_technicians)
      if(!self.xbulk_technicians)
        return self.$api.getXbulkWorkshops().then(function(res){
          console.log(res)
          if(res && res.length) {
            self.xbulk_technicians = res;
            self.exportToXbulk();
          }else{
            return false
          }
        })

      self.$dialog.confirm('', {
        view: 'export-dialog',
        //contact_city: self.$root.contact.city,
        //contact_address: '',
        //contact_zip: self.$root.contact.zip,
        technicians: self.xbulk_technicians,
        backdropClose: true,
        customClass: ['mpsConfirmDialog', 'mpsExportDialog']
      }).then((req)=>{
          let data = {
              code: self.$route.params.code,
              request: req.data
          }
          self.$root.ui.loading = true;
          return self.$api.exportToXbulk(data).then(data => {
              self.$root.ui.loading = false;
              if(data.comment){
                self.comments.push(data.comment)
              }
          })
        /*
        if(res.data.result == 'reject')
          self.considerOffer(-1);
        if(res.data.result == 'reconsider') {
          self.considerOffer( 0, {
            offer_insurance_id_company: res.data.id_company
          });
          self.newComment = "Kunden ønsker informasjon om bruk av forsikringen";
          self.sendComment()
        }
        */
      });
    },

    setAsContacted(){
      let self = this
      let data = {
        id_request: self.$root.request.id
      }
      let code = self.$route.params.code
      self.$dialog.confirm('Are you sure?', {
        cancelText: 'Avbryt',
        okText: 'Send',
        backdropClose: true,
        customClass: 'vue-js-dialog'
      }).then(function () {
        self.$root.ui.loading = true;
        return self.$api.setRequestAsContacted( code, data ).then(data => {
          self.$root.ui.loading = false;
          self.$root.request.contact_date = data.contact_date
          //$("html, body").animate({ scrollTop: $(".orderFeed").last().offset().top }, "slow");
        })
      })
    },

    setAsFinished(){
      let self = this;
      let data = {
          id_request: self.$root.request.id
      }
      self.$dialog.confirm(JSON.stringify(data), {
        view: 'finish-dialog',
        backdropClose: true,
        customClass: ['mpsFinishDialog']
      }).then((res)=>{
          if(!res.data) return;
          self.$root.ui.loading = true;
          return self.$api.setRequestAsFinished(res.data).then(data => {
              self.$root.ui.loading = false;
              self.$root.request.finished_at = data.finished_at
              self.$root.request.finish_price = data.finish_price
              self.$root.request.finish_status = data.finish_status
              self.$root.request.finish_damage_numbers = data.finish_damage_numbers
              $("html, body").animate({ scrollTop: $(".orderFeed").last().offset().top }, "slow");
          })
          //self.sendSms(res.data)
      });
      /*
      let data = {
            phone_number: self.$root.contact.phone,
            sms_text: sms_text,
            id_request: self.$root.request.id
        }
        self.$dialog.confirm(JSON.stringify(data), {
            view: 'sms-dialog',
            backdropClose: true,
            customClass: ['smsDialog', 'mpsConfirmDialog']
        }).then((res)=>{
            if(!res.data) return;
            self.sendSms(res.data)
        });
      */
      /*
      self.$dialog.confirm('Dette merker tilbudet som ferdig reparert og sender mail til oppdragsgiver', {
          cancelText: 'Avbryt',
          okText: 'Send',
          backdropClose: true,
          customClass: 'vue-js-dialog'
      }).then(function () {
          self.$root.ui.loading = true;
          return self.$api.setRequestAsFinished(self.$root.request.id).then(data => {
              self.$root.ui.loading = false;
              self.$root.request.finished_at = data.finished_at
              $("html, body").animate({ scrollTop: $(".orderFeed").last().offset().top }, "slow");
          })
      })
      */
    },
    deleteRequest: function(){
        let self = this;
        self.$dialog.confirm('Er du sikker?', {
            view: 'delete-dialog',
            backdropClose: true,
            workshops: self.$root.opqWorkshops,
            id_workshop: self.$root.request.id_workshop,
            customClass: ['mpsDeleteDialog']
        }).then(function (res) {
            self.$root.ui.loading = true;
            return false;
            let data = {
                id: self.$root.request.id
            };

            if(res.data.id_workshop) {
                data.id_workshop = res.data.id_workshop;
                data.id_workshop_current = self.$root.request.id_workshop;
            }

            let code = self.$route.params.code
            return self.$api.deleteRequest( code, data ).then(data => {
                self.$root.ui.loading = false;
                if(!data)
                    return;
                let visibility = parseInt(data.request.visibility);
                if( !visibility ){
                    self.$root.request.visibility = visibility;
                    self.$root.newRequest();
                }
                self.$root.request.id_workshop = data.request.id_workshop;
                if(data.comment){
                    self.comments.push(data.comment)
                }
            })
        })

    },
    resolveRequest: function(data){

	  var self = this;

      if(!data){
          self.$root.showModal('Not found.');
          return;
      }

      let request = data.request
      request.car_rental_approval = parseInt(request.car_rental_approval) ? 1 : 0 ;
      request.offer_estimation = parseFloat(request.offer_estimation) ? parseFloat(request.offer_estimation) : 0 ;
      request.is_urgent = parseInt(request.is_urgent) ? 1 : 0 ;

      self.$store.commit('set', {type: 'request', val: request})

      var contact = data.contact
      contact.is_naf_member = parseInt(contact.is_naf_member) ? 1 : 0 ;
      self.$store.commit('set', {type: 'contact', val: contact})

      if(data.car)
        self.$store.commit('set', {type: 'car', val: data.car})

      if(data.comments)
        self.$store.commit('set', {type: 'comments', val: data.comments})

      var damages = data.damages;
      var company = data.company;
      var companyDiscount = company ? parseFloat(company.discount) : 0;
            
      self.$root.files = [];
      for (var i = 0; i < damages.length; i++){
          var damage = damages[i];
          var files = JSON.parse(damage.images).map(function(item, idx){
            return {
              url: item
            }
          });

          var damageDiscount = parseFloat(damage.offer_discount) ? parseFloat(damage.offer_discount) : '';
          var damageDiscountReason = false;

          if(!damageDiscount && companyDiscount){
              damageDiscount = companyDiscount;
              damageDiscountReason = "Kunden har " + company.name + " Forsikring";
          }
/*
          if (data.request.id_company == 14){
	          damageDiscount = 10;
	          damageDiscountReason = "Kunden har Auto Plan";
          }
          else if (data.request.id_company == 1){
	          damageDiscount = 10;
	          damageDiscountReason = "Kunden har Codan Forsikring";
          }
*/
          damage.position = {
            top: damage.position_top,
            left: damage.position_left
          },

          damage.images = files.map(function(item,idx){
            return parseInt(idx) + self.$root.files.length;
          });
          damage.offer_discount = damageDiscount;
          damage.offer_discount_reason = damageDiscountReason;
          damage.type = damage.type ? JSON.parse(damage.type) : [];

          delete damage.position_top
          delete damage.position_left

          self.$root.files = self.$root.files.concat(files);
      }
      self.$store.commit('set', {type: 'damages', val: damages})
    },
    sendComment: function(){
      var self = this;
      if(!self.newComment) {
        self.$root.validate = true;
        return;
      }

      var jsonData = {
        ownerType: self.$route.params.type ? self.$route.params.type : 'client',
        code: self.$route.params.code,
        comment: self.newComment
      };

      self.$root.ui.loading = true;

      return self.$api.sendComment(jsonData).then(data => {
        self.$root.ui.loading = false;
        var d = new Date();
        var created_at = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() +' '+d.getHours()+':'+d.getMinutes();

        var comment = {
          id: data.id,
          text: self.newComment,
          id_owner: data.id_owner,
          created_at: created_at
        }
        var comments = self.comments
        comments.push(comment)
        self.$store.commit('set', {type: 'comments', val: comments})

        self.$root.validate = false;
        self.newComment = '';
      })
    },
    validateDamageOffer: function(damage){
      //if(parseInt(damage.offer_price) == 0 && !damage.offer_text)
      //  return false;

      let isValid = damage.type
              && (damage.offer_price && parseFloat(damage.offer_price) != NaN || parseInt(damage.offer_price) == 0);

      return isValid;
    },
    sendOffer: function(){
      var self = this;
      var isValid = true;
      if( self.$root.offerText && parseInt(self.$root.offerText.send_offer) )
        self.$root.damages.forEach(function(damage){
          if(!self.validateDamageOffer(damage))
            isValid = false;
          //if(!damage.type || !damage.offer_price || parseFloat(damage.offer_price))
        })

      if(!self.$root.offerComment){
        isValid = false;
      }

      if(!isValid){
        self.$root.showModal('Please fill required fields for assessment');
        return;
      }

      var offerComment = self.$root.offerComment
      if(self.$root.request.offer_date){
        offerComment = "<p>Tidligere tilbud</p>" + self.$root.previousOfferForm + offerComment
      }

      var comment = {
        ownerType: self.$route.params.type ? self.$route.params.type : 'client',
        code: self.$route.params.code,
        comment: offerComment
      };

      var data = {
        code: self.$route.params.code,
        comment: comment,
        damages: self.$root.damages
      }

      let request = {}

      if(self.$root.offerText && parseInt(self.$root.offerText.send_offer) === 0)
        request.offer_status = -2
//                data.save_offer = parseInt(self.$root.offerText.send_offer);

      if(Object.keys(request).length)
        data.request = request;
      
      console.log("send offer");
      console.log(data);
      
      self.$root.ui.loading = true;
      return self.$api.sendOffer(data).then(res => {
	        
        self.$root.ui.loading = false;
        var d = new Date();
        var created_at = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() +' '+d.getHours()+':'+d.getMinutes();

        var comment = {
          id: res.comment.id,
          text: offerComment,
          id_owner: res.comment.id_owner,
          created_at: created_at
        }
        self.$store.commit('setItem', {type: 'request', item: 'offer_date', val: created_at})
        if(request && request.offer_status == -2)
          self.$store.commit('setItem', {type: 'request', item: 'offer_status', val: -2})
        var comments = self.comments;
        comments.push(comment);
        self.$store.commit('set', {type: 'comments', val: comments})

        self.$root.newComment = '';
        self.$root.isOfferFormActive = false;
      })
    },
    considerOffer: function(state, considerData){
      var self = this;
      if(!self.$route.params.code) return;
      var data = {
        code: self.$route.params.code,
        offer_status: state
      }

      if(state === 0 && considerData && considerData.offer_insurance_id_company)
          data.offer_insurance_id_company = considerData.offer_insurance_id_company;

      self.$root.ui.loading = true;
      return self.$api.considerOffer(data).then(data => {
        self.$root.ui.loading = false;
        var d = new Date();
        var created_at = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() +' '+d.getHours()+':'+d.getMinutes();

        self.$root.request.offer_status = state;
        self.$root.request.offer_consideration_date = created_at;
        if(state === 0 && considerData && considerData.offer_insurance_id_company)
          self.$root.request.offer_insurance_id_company = data.offer_insurance_id_company;
      })
    },
    sendSms: function(data){
        var self = this;
        if(!data) return;

        self.$root.ui.loading = true;
        return self.$api.sendSms(data).then(data => {
            self.$root.ui.loading = false;
            self.$root.request.last_sms_date = data.last_sms_date
        })
    },
  },
  created: function(){
    var self = this;

    if(self.$route.name == 'request'){
      self.$root.ui.loading = 'getRequest';

      Promise.all([
        self.$api.getWorkshops(),
        self.$api.getRequest(this.$route.params.code, this.$route.params.type)
      ]).then(function( data ) {
	      
	    console.log("resolve request");
	    console.log(data);
        
        self.$root.resolveWorkshops(data[0]);
        self.resolveRequest(data[1]);
        if( self.$root.offerFormIsNeeded() )
          self.$api.getDamageOfferTexts( self.$root.request.id_workshop ).then( function( data ){
              self.$root.damageOfferTexts = data['damageTexts'];
              self.$root.offerTexts = data['offerTexts'];
          } );
        self.$root.ui.loading = false;
        if(self.$route.params.action == 'finish' && !self.$root.isRequestFinished()){
            self.setAsFinished()
        }

        if(self.$root.isOfferNeedConsideration() && self.isClientRoute()) {
            //self.rejectOfferDialogTimeout = setTimeout(self.rejectOffer, 30000);
        }
      });
    }
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Finish.vue?4025056a